import axios from "axios";
import store from "@/store/index.js";
import {router} from "@/router/index.js";
import { ElMessage } from 'element-plus'

const http = axios.create({
    baseURL: import.meta.env.VITE_APP_API_URL,
    timeout: 5000
});
http.interceptors.request.use(config => {
    const token = store.getters['user/getToken'];
    if (token != null && token.length >= 0) {
        config.headers.Token = token;

    }
    return config;
}, error => {
    Promise.reject(error);
})
http.interceptors.response.use(response => {
    const responseData = response.data;
    if (responseData.code === 401) {
        store.commit('user/logout');
    }
    return responseData;
}, error => {
    ElMessage({
        message:error,
        type: 'error',
        plain: true,
    })
})

export default http;